import { useAccountStore } from "../utils/store"

export const useAccount = () => {
  const { account } = useAccountStore()

  // if (!account) {
  //   throw new Error("User is not authenticated")
  // }

  return {
    account
  }
}
